var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgSendVotingReminder = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.08,
    width: 24,
    height: 24,
    rx: 3,
    fill: "#0080FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5552 18.3699C10.6737 19.3476 11.5032 20.0882 12.5105 20.0882C13.5177 20.0882 14.3473 19.3328 14.4659 18.3699C13.8882 18.4291 13.2364 18.4588 12.5105 18.4588C11.7846 18.4588 11.1477 18.4292 10.5552 18.3699Z",
    fill: "#0080FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9023 15.2284L16.8802 13.0953C16.7024 12.725 16.6136 12.3399 16.6136 11.9252V11.1401C16.6136 9.30327 15.3693 7.76276 13.6806 7.30357V7.18505C13.6806 6.53326 13.1474 6 12.4956 6C11.8438 6 11.3105 6.53326 11.3105 7.18505V7.30357C9.62188 7.76274 8.37761 9.30335 8.37761 11.1401V11.9252C8.37761 12.3251 8.28875 12.725 8.11103 13.0953L7.08892 15.2284C6.86677 15.7025 7.07415 16.2802 7.56298 16.5023C8.39247 16.8726 9.93309 17.3021 12.4956 17.3021C15.0582 17.3021 16.584 16.8577 17.4283 16.5023C17.9318 16.28 18.1392 15.7023 17.9022 15.2284H17.9023Z",
    fill: "#0080FF"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSendVotingReminder, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/send_voting_reminder.58cbd356.svg";
export { ForwardRef as ReactComponent };